import { render, staticRenderFns } from "./debateSidebar.vue?vue&type=template&id=670ad605&scoped=true&"
import script from "./debateSidebar.vue?vue&type=script&lang=js&"
export * from "./debateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./debateSidebar.vue?vue&type=style&index=0&id=670ad605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ad605",
  null
  
)

export default component.exports